"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _hooks = require("../../../hooks");

var _components = require("../../../components");

var _upsellItemModule = _interopRequireDefault(require("./upsellItem.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var UpsellItem = function UpsellItem(_ref) {
  var addToCart = _ref.addToCart,
      cellType = _ref.cellType,
      dataTest = _ref.dataTest,
      imageSrc = _ref.imageSrc,
      name = _ref.name,
      price = _ref.price;

  var _useTemplate$useCell = _hooks.useTemplate.useCell(cellType),
      labelTextStyles = _useTemplate$useCell.labelTextStyles,
      views = _useTemplate$useCell.views,
      buttons = _useTemplate$useCell.buttons;

  return /*#__PURE__*/_react["default"].createElement(_components.View, {
    dataTest: dataTest,
    type: views.background,
    Component: "li",
    direction: "column",
    className: [_upsellItemModule["default"].upsellItem, "upsell-item"]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _upsellItemModule["default"]["upsellItem-info"]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _upsellItemModule["default"]["upsellItem-info-image"]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundImage: "url(".concat(imageSrc, ")")
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _upsellItemModule["default"]["upsellItem-info-title"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.primary,
    className: _upsellItemModule["default"].name
  }, name))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _upsellItemModule["default"]["upsellItem-button"]
  }, /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    type: buttons.primary,
    className: _upsellItemModule["default"].btn,
    onClick: addToCart
  }, price)));
};

UpsellItem.displayName = "UpsellItemType4";
var _default = UpsellItem;
exports["default"] = _default;